import { render, staticRenderFns } from "./ScreenConfigureIntegrations.vue?vue&type=template&id=7656104a&scoped=true"
import script from "./ScreenConfigureIntegrations.vue?vue&type=script&lang=js"
export * from "./ScreenConfigureIntegrations.vue?vue&type=script&lang=js"
import style0 from "./ScreenConfigureIntegrations.vue?vue&type=style&index=0&id=7656104a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7656104a",
  null
  
)

export default component.exports